export const $dataPiano = $('#data-piano');
export const $piani = $('#piani');
export const $data = $('#data');
export const $edificio = $('g[id^="edificio"]');
export const $edifici = $('#edifici');
export const $dataOcc = $('#data-occ');
export const $piano = $('g[id^="Piano"]');

export default {
    buildings: $('#buildings'),
        init() {
            if (wp['is_mobile']) {
                this.buildings.find('.collapse-toggle').click(function (e) {
                    e.preventDefault();
                    $(this).closest('.collapse-container').toggleClass('active').find('.collapse-content').stop().slideToggle();
                });
            }

            $('.zoom').zoom({
                url: $(this).attr('href'),
            });

            $('[data-action="open-form"]').click(function (e) {
                e.preventDefault();
                $('.aptcode').val(wp['activeLetter'] + wp['activeNumber']);
                $('[data-target="#contactModal"]').trigger('click');
            });

        $('select[name="edificio"]').on('select2:select', function () {
            $(this).closest('form').trigger('submit');
        });

        $('select[name="piano"]').on('select2:select', function () {
            window.location.href = wp.link + '?edificio=' + wp['activeLetter'] + '&piano=' + this.value;
        });

        $edificio.click(function (e) {
            e.preventDefault();

            const collapseId = $(this).attr('id');
            if (
                collapseId === 'edificio-m-e-fh'
                || collapseId === 'edificio-d-r-sh'
                || collapseId === 'edificio-d-r-p'
                || collapseId === 'edificio-d-r-rec'
                || collapseId === 'edificio-d-r-mk'
                || collapseId === 'edificio-el'
            ) {
                const $collapse = $('#collapse-' + collapseId);

                $('.explore-content').collapse('hide');

                if ($collapse.length > 0) {
                    $collapse.collapse('toggle');
                    $('html, body').animate({
                        scrollTop: ($('g#' + collapseId).offset().top) - (64 * 2),
                    }, 1000);
                }

                return false;
            }

            const id = $(this).attr('id').replace('edificio-', '');
            window.location.href = '?edificio=' + id.toUpperCase();

            if (wp.template.includes('homepage')) {
                window.location.href = wp.link + (wp.lang === 'en' ? '/en/planimetrie' : '/planimetrie') + '?edificio=' + id.toUpperCase();
            }
        });

        $('#plan-example').click(function (e) {
            e.preventDefault();
            const number = $(this).attr('id').replace('Piano_', '');
            window.location.href = wp.link + '?edificio=' + wp['activeLetter'] + '&piano=' + number;
        });

        $('.edificio-occupied').hover(function () {
            if ((!$(this).hasClass('inactive')) && (!$(this).hasClass('unavailable'))) {
                $dataOcc.find('.data-1 span').text($(this).data('letter'));
                $('.data-2 b').show();
                $('.data-2 .data-2-temp').remove();
                $dataOcc.find('.data-2 span').text(wp['labelOccupato']);
                const cx = $edifici.offset().left;
                const cy = $edifici.offset().top;
                const dw = $dataOcc.width();
                const dh = $dataOcc.height();
                const w = $(this).width();
                const x = $(this).offset().left;
                const y = $(this).offset().top;
                $dataOcc.addClass('active');
                $dataOcc.css('top', y - cy - dh + 200 + 'px');
                $dataOcc.css('left', x - cx + (w / 2) - (dw / 2) + 'px');
            }
        }, function () {
            $dataOcc.removeClass('active');
            $('#unavailable-data').removeClass('active');
        });

        $edificio.hover(function () {
            if ((!$(this).hasClass('inactive')) && (!$(this).hasClass('unavailable'))) {
                const letter = $(this).attr('id').replace('edificio-', '');
                const edificio = getEdificioByLetter(letter);

                if (edificio) {
                    if (edificio['facilities_edificio_name']) {
                        let facilities = '';

                        for (let i in edificio['facilities_edificio']) {
                            facilities += (i === '0' ? '' : ' - ') + edificio['facilities_edificio'][i]['facility_edificio'];
                        }

                        $data.find('.data-1 span').text(edificio['nome_edificio']);
                        $data.find('.data-2 b').hide();
                        $data.find('.data-2 .data-2-temp').remove();
                        $data.find('.data-2').prepend('<b class="data-2-temp">'+edificio['facilities_edificio_name']+'</b>')
                        console.log(edificio);
                        if (edificio['facilities_edificio_name'] === 'Service Hub' && edificio['id_edificio'] === 'd-r-sh') {
                            $data.addClass('extend');
                            $data.addClass('extend-d-r-sh');
                            $data.find('.data-2').addClass('extend');
                        } else if (edificio['id_edificio'] === 'el') {
                            $data.addClass('single-extend');
                            $data.find('.data-1').addClass('d-none');
                        } else {
                            $data.removeClass('extend');
                            $data.find('.data-2').removeClass('extend');
                        }
                        $data.find('.data-2 span').text(facilities);
                        $data.find('.data-3').addClass('d-none');
                        $data.find('.data-4').addClass('d-none');
                    } else {
                        $data.find('.data-1 span').text(edificio['nome_edificio']);
                        $data.find('.data-2 b').show();
                        $data.find('.data-2 .data-2-temp').remove();
                        $data.removeClass('extend');
                        $data.removeClass('extend-d-r-sh');
                        $data.find('.data-2').removeClass('extend');
                        $data.find('.data-2 span').text(edificio['numero_piani']);
                        $data.find('.data-3').removeClass('d-none').find('span').text(edificio.mq);
                        $data.find('.data-4').removeClass('d-none').find('span').text(wp['remainingSurfaces'][letter]);
                    }

                    const dataWidth = 170 * $data.children().not('.d-none').length;
                    const dataNumChildren = $data.children().not('.d-none').length;
                    $data.find('div').css('width', (dataWidth / dataNumChildren) + 'px');
                    $data.css('width', dataWidth + 'px');
                    if ($data.hasClass('extend')) {
                        $data.css('width',  ((dataWidth / dataNumChildren)*4)+75+'px');
                        $data.find('.data-2').css('width',  ((dataWidth / dataNumChildren)*3)+75+'px');
                    }
                    if ($data.hasClass('extend') && $data.hasClass('extend-d-r-sh')) {
                        $data.css('width',  ((dataWidth / dataNumChildren)*3)+100+'px');
                        $data.find('.data-2').css('width',  ((dataWidth / dataNumChildren)*2)+100+'px');
                    }
                    if ($data.hasClass('single-extend')) {
                        $data.css('width',  ((dataWidth / dataNumChildren))+75+'px');
                        $data.find('.data-2').css('width',  ((dataWidth / dataNumChildren))+75+'px');
                    }

                    const cx = $edifici.offset().left;
                    const cy = $edifici.offset().top;
                    const dw = $data.width();
                    const dh = $data.height();
                    const w = $(this).width();
                    const x = $(this).offset().left;
                    const y = $(this).offset().top;
                    $data.addClass('active');
                    $data.css('top', y - cy - dh + 170 + 'px');
                    $data.css('left', x - cx + (w / 2) - (dw / 2) + 'px');
                }
            }
        }, function () {
            $data.removeClass('active');
            $('#unavailable-data').removeClass('active');
        });

        // Hover piano
        $piano.hover(function () {
            //if((!$(this).hasClass('busy'))) {
            const number = $(this).attr('id').replace('Piano_', '');
            const piano = getPianoByNumber(wp['activeLetter'].toLowerCase(), number);

            console.log(piano);

            if (piano) {
                $('.value-1').text(piano['piano']);
                if (piano['occupato']) {
                    $('.value-2').text('Occupato da ' + piano['occupante']);
                    $(this).addClass('busy');
                } else {
                    $('.value-2').text(wp['labelLibero']);
                }

                let occ = wp['labelLibero'];
                if (piano['occupato']) {
                    occ = wp['labelOccupato'];
                }

                let tenant = '--';
                if (piano['occupante']) {
                    tenant = piano['occupante'];
                }

                let mq = '--';
                if (piano['piano_mq']) {
                    mq = piano['piano_mq'];
                }

                let mq_free = '--';
                if (piano['piano_mq_free']) {
                    mq_free = piano['piano_mq_free'];
                }

                $('.data-piano-1 span').text(piano['piano']);
                $('.data-piano-2 span').text(occ);
                $('.data-piano-3 span').text(tenant);
                $('.data-piano-4 span').text(mq);
                $('.data-piano-5 span').text(mq_free);

                const cx = $piani.offset().left;
                const cy = $piani.offset().top;
                const dw = $dataPiano.width();
                const dh = $dataPiano.height();
                const w = $(this).width();
                // var h = $(this).height();
                const x = $(this).offset().left;
                const y = $(this).offset().top;
                $dataPiano.addClass('active');
                $dataPiano.css('top', ((y - cy - dh) - 6) + 'px');
                $dataPiano.css('left', ((x - cx + (w / 2) - (dw / 2)) + 200) + 'px');
            } else {
                $('.value-1').text();
                $('.value-2').text();
            }
            //}
        }, function () {
            $dataPiano.removeClass('active');
            $('.value-1').text();
            $('.value-2').text();
        });

        $piano.click(function (e) {
            e.preventDefault();
            const number = $(this).attr('id').replace('Piano_', '');
            window.location.href = wp.link + '?edificio=' + wp['activeLetter'] + '&piano=' + number;
        });

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
    };

    export function getEdificioByLetter(letter)
    {
        if (wp.planimetrie) {
            for (let i = 0; i < wp.planimetrie.length; i++) {
                if (letter === wp.planimetrie[i]['id_edificio']) {
                    return wp.planimetrie[i];
                }
            }
        }
        return false;
    }

    export function getPianoByNumber(letter, number)
    {
        let edificio = false;
        if (wp.planimetrie) {
            for (let i = 0; i < wp.planimetrie.length; i++) {
                if (letter === wp.planimetrie[i]['id_edificio']) {
                    edificio = wp.planimetrie[i];
                    if (edificio) {
                        for (let e = 0; e < edificio['piani'].length; e++) {
                            if (edificio['piani'][e]['piano'] === number) {
                                return edificio['piani'][e];
                            }
                        }
                    }
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./scripts/routes/planimetrie.js